let constCommonData: any = {
  loading: undefined,
  model: undefined,
  videoUrl: '',
  transId: '',
  isShareNew: false,
  getRoleSplitTipTimer: null,
  getWulabTimer: null,
};

const setCommonData = (key, val) => {
  constCommonData[key] = val;
};

const getCommonData = (key) => {
  return constCommonData[key];
};
const destroyCommonData = () => {
  constCommonData = {};
};

export { setCommonData, getCommonData, destroyCommonData };
